// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pb-0";
export var animationContainer = "_pb-1";
export var itemPrice = "_pb-a";
export var itemizedContent = "_pb-9";
export var itemizedHeader = "_pb-7";
export var itemizedRow = "_pb-8";
export var itemizedSection = "_pb-6";
export var modalContent = "_pb-2";
export var orderName = "_pb-3";
export var refundOption = "_pb-4";
export var refundOptionsContainer = "_pb-5";
export var shippingLabel = "_pb-b";
export var totalRow = "_pb-c";